import { mutationTypes, actionTypes } from '../../../types/';

export default {
	state: {
		viewerOptions: {},
	},
	mutations: {
		[mutationTypes.viewer3dSetModel](state, viewerOptions) {
			state.viewerOptions = viewerOptions;
		},
	},
	actions: {
		[actionTypes.viewer3dLoadID]({ commit, rootState }, { mediaObjectID, quality = 'high' }) {
			const mediaObject = rootState.currentMediaObjectMap.get(mediaObjectID);
			const threeDResourceMap = Object.values(mediaObject.threeDResourceMap).find(
				(obj) => Object.keys(obj).length >= 1
			);
			const threeDViewerOptions = Object.values(mediaObject.threeDViewerOptions).find(
				(obj) => Object.keys(obj).length > 0
			);
			const modelUrl = Object.values(mediaObject.Sources).find((url) => !!url);

			const resourceMap = Object.entries(threeDResourceMap).reduce((acc, [url, name]) => {
				acc[fixResolution(url, quality, name)] = name;
				return acc;
			}, {});

			commit(mutationTypes.viewer3dSetModel, {
				mediaObjectID,
				quality,
				modelUrl,
				resourceMap,
				hdrUrls: ['px', 'nx', 'py', 'ny', 'pz', 'nz'].map(
					(name) => `${window.location.host.includes('localhost') ? '' : '.'}/hdri/256_SketchFab/${name}.hdr`
				),
				options: Object.assign(
					{
						spin: false, // constantly spin the model around its z axis
						exposure: 2.6,
					},
					threeDViewerOptions
				),
			});
		},
	},
};

function fixResolution(source, quality, name) {
	const qualityMap = {
		low: '512',
		medium: '1024',
		high: '2048',
		original: name,
	};
	return source.replace(/\/[0-9]+$/, `/${qualityMap[quality]}`);
}
